<template>
    <div id="main">
        <div class="page page-container">
            <div class="novo-tiportr">
                <h1 class="title">
                    {{ $t("tipo-agro-visita") }}
                </h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li>
                            <a class="a-inativo">{{ 
                                    isAgro ?
                                    $t("agro") :
                                    $t("vendas")
                            }}</a>
                        </li>
                        <li>
                            <a class="a-inativo">{{
                                    isAgro ?
                                    $t("agro-cadastros") :
                                    $t("crm")
                            }}</a>
                        </li>
                        <li>
                            <a
                                @click="
                                    $router.push({
                                        name: `${abrev}-tipo-agrovisita`,
                                    })
                                "
                                >{{ $t("tipo-agro-visitas") }}</a
                            >
                        </li>
                        <li>
                            <a aria-current="page">{{
                                $route.params.id
                                    ? $route.params.descricao
                                    : $t("novo")
                            }}</a>
                        </li>
                    </ul>
                </nav>

                <div class="columns">
                    <div class="column is-2">
                        <v-input
                            :id="'codigo'"
                            ref="idtiportrerpInput"
                            v-model="tiportr.idtiportrerp"
                            placeholder="placeholder-preencha"
                            :maxlength="30"
                            title="codigo"
                            uppercase
                            :required="isUpdate"
                            :invalid="isUpdate && isNull(tiportr.idtiportrerp)"
                            :tooltipLabel="isUpdate ? 'regra-prefixo-GA-edicao' : 'regra-prefixo-GA-criacao'"
                        />
                    </div>
                    <div class="column">
                        <v-input
                            v-model="tiportr.descricao"
                            :id="'descricao'"
                            :placeholder="'descricao-do-tipo-agro-visita-placeholder'"
                            :maxlength="100"
                            :title="'descricao'"
                            :msg="'msg-campo-obrigatorio'"
                            :invalid="!tiportr.descricao"
                            ref="descricaoInput"
                            uppercase
                            required
                            :disabled="
                                (isUpdate && !permissao.update) ||
                                (!isUpdate && !permissao.create)
                            "
                        />
                    </div>
                </div>

                <div class="form-buttons">
                    <button
                        class="delete-btn"
                        type="button"
                        @click="$router.push({ name: `${abrev}-tipo-agrovisita` })"
                    >
                        {{ $t("voltar") }}
                    </button>
                    <button
                        v-if="
                            ((!isUpdate && permissao.create) ||
                                (isUpdate && permissao.update)) &&
                            !tipoagrovisitaIntegracao
                        "
                        class="save-btn"
                        type="button"
                        @click="saveTipoRtr()"
                        :disabled="isSaving"
                    >
                        {{ $t("salvar") }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TipoRtrService from "@/services/agro/TipoRtrService";
import TipoRtrValidation from "@/services/validations/TipoRtrValidation";

export default {
    data() {
        return {
            tipoagrovisitaIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("TIPORTR"),
            service: new TipoRtrService(this.$http, this.$router),
            validation: new TipoRtrValidation(this.$root.msgs),
            isSaving: false,
            tiportr: {},
            title: "",
            msgs: [],
            isUpdate: false,
            abrev: this.$route.meta.contexto.slice(0,3),
            isVenda: this.$route.meta.contexto == "vendas",
            isAgro: this.$route.meta.contexto == "agro",
            originalIdErp: ''
        };
    },
    created() {
        if (this.$route.params.id) {
            this.isUpdate = true;
        }

        if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0,4);
            this.permissao = this.hasPermissionAccess(
                "agro",
                "agro-cadastros",
                "agro-tipo-agrovisita"
            );
        }else if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                "vendas",
                "crm",
                "ven-tipo-agrovisita"
            );
        }

        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "tipo-agro-visitas" },
            });
        } else {
            if (this.$route.params.id) {
                this.carregarDados(this.$route.params.id);
            }
        }
    },
    mounted() {
        this.$refs.descricaoInput.$refs.typed.focus();
    },
    methods: {
        carregarDados(id) {
            this.service.find(id, this.abrev).then((body) => {
                if (body.content) {
                    this.tiportr = body.content;
                    this.title = this.tiportr.descricao;
                    this.originalIdErp = this.tiportr.idtiportrerp;
                } else {
                    this.$router.push({ name: `${this.abrev}-tipo-agrovisita-new` });
                }
            });
        },
        saveTipoRtr() {
            this.tiportr = this.mapTosave(this.tiportr);
            if (this.validation.validate(this.tiportr, this.$refs)) {
                if(this.isPrefixSovisInIdErpInvalid(this.tiportr.idtiportrerp || '', this.originalIdErp)) {
                    const message = 
                        this.isUpdate ? 'nao-permitido-prefixo-ga-alterar' : 'nao-permitido-prefixo-ga-no-campo-codigo';
            
                    return this.$root.showMessage('alert', message, true);
                }

                this.isSaving = true;

                this.service.save(this.tiportr, this.abrev)
                    .then((body) => {
                        let msg = "msg-tipoagro-visita-salva";

                        if (this.tiportr.id) {
                            msg = "msg-tipoagro-visita-edita";
                        }

                        this.tiportr = body.content;
                        this.originalIdErp = this.tiportr.idtiportrerp;
                        this.$root.showMessage("success", msg);
                        this.redirectToList();
                        this.isUpdate = true;
                    })
                    .catch((e) => {
                        if (this.$te(e.body.message)) {
                            if (e.body.message == "msg-codigo-duplicado-n") {
                                this.msgs.push(
                                    this.$root.showMessage(
                                        "alert", 
                                        this.$t('msg-codigo-duplicado-n', { n: this.tiportr.idtiportrerp }), 
                                        true, 
                                        false
                                    )
                                );
                            } else {
                                this.msgs.push(
                                    this.$root.showMessage("alert", e.body.message, true)
                                );
                            }
                        } else {
                            if (e.body.message) {
                                this.$root.showMessage("error", e.body.message);
                            } else {
                                this.$root.showMessage(
                                    "error",
                                    "msg-problema-realizar-acao"
                                );
                            }
                        }
                    })
                    .finally((_) => {
                        this.isSaving = false;
                    });
            }
        },
        redirectToList() {
            this.$router.push({
                name: `${this.abrev}-tipo-agrovisita-edit`,
                params: { id: this.tiportr.id, descricao: this.tiportr.descricao },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
}
.page {
    position: relative;
    margin-bottom: 40px;

    .novo-tiportr {
        position: relative;
        width: 100%;
        margin-bottom: 20px;
        height: 100%;
        padding-top: 0;

        > h1 {
            padding-top: 20px;
            margin-bottom: 40px;
        }
    }
}

.form-buttons {
    right: 0;
}

@media only screen and (min-width: 760px) {
    nav.breadcrumb {
        margin-right: 410px;
    }
}
</style>